import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const sendNotification = createAsyncThunk(
  "notification/sendNotification",
  async ({ token, groupName, topic, msg }, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(
        `https://student.vstu.by/api/notification`,
        { groupName, topic, msg },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getNotificationsStudent = createAsyncThunk(
  `notification/getNotificationsStudent`,
  async (token, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        "https://student.vstu.by/api/notification/student",
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getNotificationsTeacher = createAsyncThunk(
  `notification/getNotificationsTeacher`,
  async (token, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        "https://student.vstu.by/api/notification/teacher",
        config
      );

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  notification: null,
  loadingNotification: false,
  notificationStatus: null,
  notificationError: null,
  studentNotifications: [],
  studentNotificationsStatus: null,
  studentNotificationsError: false,
  teacherNotifications: [],
  teacherNotificationsStatus: null,
  teacherNotificationsError: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    clearNotifications(state) {
      state.notification = null;
      state.loadingNotification = false;
      state.notificationError = null;
      state.studentNotifications = [];
      state.studentNotificationsStatus = null;
      state.studentNotificationsError = null;
      state.teacherNotifications = [];
      state.teacherNotificationsStatus = null;
      state.teacherNotificationsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state) => {
        state.loadingNotification = true;
        state.notificationStatus = "pending";
        state.notificationError = null;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.loadingNotification = false;
        state.notificationStatus = "resolved";
        state.notification = action.payload;
        state.notificationError = null;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.loadingNotification = false;
        state.notificationError = null;
        state.notificationStatus = "rejected";
      })
      .addCase(getNotificationsStudent.pending, (state) => {
        state.studentNotificationsStatus = "loading";
        state.studentNotificationsError = null;
      })
      .addCase(getNotificationsStudent.fulfilled, (state, action) => {
        state.studentNotificationsStatus = "resolved";
        state.studentNotifications = action.payload;
        state.studentNotificationsError = null;
      })
      .addCase(getNotificationsStudent.rejected, (state, action) => {
        state.studentNotificationsStatus = "rejected";
        state.studentNotificationsError = action.payload;
      })
      .addCase(getNotificationsTeacher.pending, (state) => {
        state.teacherNotificationsStatus = "resolved";
        state.teacherNotificationsError = null;
      })
      .addCase(getNotificationsTeacher.fulfilled, (state, action) => {
        state.teacherNotificationsStatus = "resolved";
        state.teacherNotifications = action.payload;
        state.teacherNotificationsError = null;
      })
      .addCase(getNotificationsTeacher.rejected, (state, action) => {
        state.teacherNotificationsStatus = "rejected";
        state.teacherNotificationsError = action.payload;
      });
  },
});

export const { clearNotifications } = notificationSlice.actions;

export const notificationReducer = notificationSlice.reducer;
